module.exports = __webpack_public_path__ + "content/fc8bbf677d4bc9aa695128e317826c11.svg";